import {
  FETCH_CUSTOMERS_DATA,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
} from "./actionTypes";

export const fetchCustomersData = () => ({
  type: FETCH_CUSTOMERS_DATA,
});

export const fetchCustomersSuccess = (data) => ({
  type: FETCH_CUSTOMERS_SUCCESS,
  payload: data,
});

export const fetchCustomersFailure = (error) => ({
  type: FETCH_CUSTOMERS_FAILURE,
  payload: error,
});
